const Main = () => import(/* webpackChunkName: "exoty" */ './main.vue');

export const ROUTE_NAME_HOMEPAGE = 'Home' as const;

export default [
    {
        path: '/',
        name: ROUTE_NAME_HOMEPAGE,
        component: Main,
        meta: { requiresAuth: true }
    }
];
